'use client';
var classes = {"field":"m_45c4369d"};

export { classes as default };
//# sourceMappingURL=PillsInput.module.css.mjs.map
